import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { BreadcrumbsService } from './breadcrumbs.service';

@Component({
  selector: 'breadcrumbs',
  standalone: true,
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, RouterLink, NgClass, NgTemplateOutlet],
})
export class BreadcrumbsComponent {
  private _breadcrumbSrv = inject(BreadcrumbsService);

  separatorType = input<'icon' | 'text'>('icon');
  separator = input('chevron');
  firstItemCssClass = input('mx-1 text-gray-400 text-gray-500 ');
  itemCssClass = input('inline-flex items-center text-sm font-medium');
  lastItemCssClass = input('text-gray-800 dark:text-gray-300');
  separatorCssClass = input('mx-1 text-gray-400');

  items = computed(() =>
    this._breadcrumbSrv.breadcrumbs().map(elem => {
      return {
        ...elem,
        label: elem.label,
      };
    })
  );
}
